export enum FilterMethod {
  Equal = '==',
  NotEqual = '!=',
  GreaterThen = '>',
  GreaterThenOrEqual = '>=',
  LessThen = '<',
  LessThenOrEqual = '<=',
  In = 'in',
  ArrayContains = 'array-contains',
  ArrayContainsAny = 'array-contains-any'
}
